import { AwsRum } from "aws-rum-web";

import type { RumWebClientConfig } from "./rum";

type EnabledRumWebClientConfig = Extract<RumWebClientConfig, { enabled: true }>;

const RUM_APPLICATION_VERSION = "0.1.0";

let hasAttemptedRumInitialization = false;
let rumClient: AwsRum | null = null;

export function initializeRum(config: EnabledRumWebClientConfig): AwsRum | null {
  // AWS RUM should only be constructed once per page load, including React StrictMode remounts.
  if (hasAttemptedRumInitialization) {
    return rumClient;
  }

  hasAttemptedRumInitialization = true;

  try {
    rumClient = new AwsRum(
      config.applicationId,
      RUM_APPLICATION_VERSION,
      config.applicationRegion,
      {
        allowCookies: config.allowCookies,
        enableXRay: config.enableXRay,
        endpoint: config.endpoint,
        guestRoleArn: config.guestRoleArn,
        identityPoolId: config.identityPoolId,
        sessionSampleRate: config.sessionSampleRate,
        telemetries: config.telemetries,
      }
    );
  } catch (error) {
    console.warn("Failed to initialize CloudWatch RUM", error);
  }

  return rumClient;
}
